module.exports = __webpack_public_path__ + "img/horizontal_stacked_bar_chart.0ee7f43c.svg";